import {
  Autocomplete,
  Box,
  Button,
  CircularProgress,
  createFilterOptions,
  Divider,
  Grid,
  IconButton,
  MenuItem,
  Paper,
  Select,
  TextField,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { ErrorMessage, Field, Form, Formik } from "formik";
import * as Yup from "yup";
import { Clear, FileUploadOutlined } from "@mui/icons-material";
import { color } from "../../../StyleData/Config";
import { axiosPrivate } from "../../../axios/axios";
import { masterAPI } from "../dataConfig";
import ErrorProps from "../../../Component/Errorprops";
import { toast } from "react-toastify";
const AssetTypeQuesModal = ({ mode, handleCloseClick, editData }) => {
  const [assetType, setAssetType] = useState([]);
  const [question, setQuestion] = useState([]);
  const [loading, setLoading] = useState(false);
  const [autoCom, setAutoCom] = useState({
    assetTypeName: mode === "Edit" ? editData.assetTypeName : "",
    questionName: mode === "Edit" ? editData.question : "",
  });

  const OPTIONS_LIMIT = 10;
  const defaultFilterOptions = createFilterOptions();

  const filterOptions = (options, state) => {
    return defaultFilterOptions(options, state);
  };
  const CustomPaper = (props) => {
    return <Paper elevation={8} {...props} />;
  };

  useEffect(() => {
   getData()
  }, []);

  const getData=async()=>{
    setLoading(true);
    const assetTypeLink = masterAPI["assetType"].link;
   await axiosPrivate
      .get(`${assetTypeLink}`)
      .then((res) => {
        setLoading(false);
        setAssetType(res.data.result);
      })
      .catch((e) => {
        setAssetType([]);
        console.log(e, "assetType assetTypeQues");
      });
    const questionLink = masterAPI["question"].link;
   await axiosPrivate
      .get(`${questionLink}`)
      .then((res) => {
        console.log(res.data.result)
        setLoading(false);
        setQuestion(res.data.result);
      })
      .catch((e) => {
        setQuestion([]);
        console.log(e, "question assetTypeQues");
      });
  }

  const initialValue = {
    assetTypeId: mode === "Edit" ? editData.assetTypeId : null,
    questionId: mode === "Edit" ? editData.questionId : null,
      code: mode === "Edit" ? editData.code : "",
  };

  const onSubmit = async(value) => {
    console.log(value);
    setLoading(true);
    const createLink = masterAPI["assetTypeQuestion"].create;
    const updateLink = masterAPI["assetTypeQuestion"].update;
    if (mode === "Create") {
     await axiosPrivate
        .post(`${createLink}`, value)
        .then((res) => {
          console.log(res.data);
          setLoading(false);
          handleCloseClick();
        })
        .catch((e) => {
          setLoading(false);
          console.log(e, "assetTypeQues");
        });
    } else {
      const updateAC = {
        id: editData.id,
        ...value,
      };
     await axiosPrivate
        .put(`${updateLink}`, updateAC)
        .then((res) => {
          console.log(res.data);
          setLoading(false);
          handleCloseClick();
        })
        .catch((e) => {
          setLoading(false);
          console.log(e, "assetTypeQues");
        });
    }
  };

  const handleCancel = () => {
    handleCloseClick();
  };
 const validationSchema = Yup.object().shape({

  code:Yup.string().required("Code is required"),
  assetTypeId:Yup.string().required("Asset Type is required"),
    questionId:Yup.string().required("Question is required"),
 });
  return (
    <Box sx={{ p: color.masterPageDialogPadding }}>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          width: "100%",
        }}
      >
        <Typography
          sx={{
            color: color.masterDialogTitleColor,
            fontSize: color.masterDialogFontSize,
          }}
        >
          {mode === "Edit"
            ? "Update Asset Type Inspection Task"
            : "New Asset Type Inspection Task"}
        </Typography>
        <IconButton onClick={handleCancel}>
          <Clear />
        </IconButton>
      </Box>
      <Divider sx={{ border: "1px solid rgb(0 0 0 / 17%)", mb: "15px" }} />
      <Formik initialValues={initialValue} validationSchema={validationSchema}onSubmit={onSubmit}>
        {({ handleChange, setFieldValue, values, resetForm }) => (
          <Form>
            <Grid container spacing={"1rem"}>
               <Grid item xs={12} md={6}>
                              <Typography
                                sx={{
                                  fontWeight: color.labelFontWeight,
                                  mb: color.labelmb,
                                  fontSize: color.labelFont,
                                  color: color.labelColor,
                                }}
                              >
                                Code
                              </Typography>
                              <Field
                                as={TextField}
                                size={"small"}
                                type="text"
                                name="code"
                                placeholder="Enter Code"
                                fullWidth
                                sx={{
                                  ".MuiInputBase-input": {
                                    // letterSpacing: "0.2rem",
              
                                    "&::placeholder": {
                                      // color: "green",
                                      opacity: 1,
                                      color: color.placeholderColor,
                                      fontSize: "13px",
                                    },
                                  },
                                }}
                              />
                                             <ErrorMessage name="code">
                                              {(error) => <ErrorProps>{error}</ErrorProps>}
                                            </ErrorMessage>
                            </Grid>
              <Grid item xs={12} md={6}>
                <Typography
                  sx={{
                    fontWeight: color.labelFontWeight,
                    mb: color.labelmb,
                    fontSize: color.labelFont,
                    color: color.labelColor,
                  }}
                >
                  Asset Type
                </Typography>

               <Field name="assetTypeId">
  {({ field, form }) => (
    <Autocomplete
      value={
        assetType.find((x) => x.id === form.values.assetTypeId) || null
      }
      inputValue={autoCom.assetTypeName}
      onChange={(event, value) => {
        if (value) {
          form.setFieldValue("assetTypeId", value.id);
          setAutoCom({
            ...autoCom,
            assetTypeName: `${value.code}-${value.assetTypeName}`,
          });
        } else {
          form.setFieldValue("assetTypeId", null);
          setAutoCom({ ...autoCom, assetTypeName: "" });
        }
      }}
      onInputChange={(e, v) => {
        setAutoCom({ ...autoCom, assetTypeName: v });
      }}
      options={assetType}
      loading={assetType.length === 0}
      filterOptions={filterOptions}
      PaperComponent={CustomPaper}
      getOptionLabel={(option) =>
        typeof option === "string"
          ? option
          : `${option.code}-${option.assetTypeName}`
      }
      getOptionDisabled={(option) =>
        editData.id === option.id && mode === "Edit"
      }
      renderInput={(params) => (
        <TextField
          {...params}
          name="assetTypeId"
          placeholder="Search Asset Type"
          size="small"
          InputProps={{
            ...params.InputProps,
            endAdornment: (
              <>
                {assetType.length === 0 ? (
                  <CircularProgress color="inherit" size={20} />
                ) : null}
                {params.InputProps.endAdornment}
              </>
            ),
          }}
        />
      )}
    />
  )}
</Field>

<ErrorMessage name="assetTypeId">
  {(error) => <ErrorProps>{error}</ErrorProps>}
</ErrorMessage>

              </Grid>
              <Grid item xs={12} md={6}>
                <Typography
                  sx={{
                    fontWeight: color.labelFontWeight,
                    mb: color.labelmb,
                    fontSize: color.labelFont,
                    color: color.labelColor,
                  }}
                >
                  Inspection Task
                </Typography>
              <Autocomplete
  value={
    question.find((x) => x.id === values.questionId) || null
  }
  inputValue={autoCom.questionName}
  onInputChange={(e, v) => {
    setAutoCom({ ...autoCom, questionName: v });
  }}
  onChange={(event, value) => {
    if (value) {
      setFieldValue("questionId", value.id);
      setAutoCom({ ...autoCom, questionName: value.question });
    } else {
      setFieldValue("questionId", null);
      setAutoCom({ ...autoCom, questionName: "" });
    }
  }}
  options={question}
  getOptionLabel={(option) =>
    typeof option === "string" ? option : option.question
  }
  getOptionDisabled={(option) =>
    editData.id === option.id && mode === "Edit"
  }
  filterOptions={filterOptions}
  PaperComponent={CustomPaper}
  loading={question.length === 0}
  renderInput={(params) => (
    <TextField
      {...params}
      placeholder="Search Inspection Task"
      size="small"
      InputProps={{
        ...params.InputProps,
        endAdornment: (
          <>
            {question.length === 0 ? (
              <CircularProgress color="inherit" size={20} />
            ) : null}
            {params.InputProps.endAdornment}
          </>
        ),
      }}
    />
  )}
/>
<ErrorMessage name="questionId">
                                              {(error) => <ErrorProps>{error}</ErrorProps>}
                                            </ErrorMessage>
              </Grid>

              <Grid
                container
                item
                xs={12}
                justifyContent={"flex-end"}
                gap="1rem"
              >
                <Button
                  onClick={handleCancel}
                  variant="contained"
                  sx={{
                    backgroundColor: color.TableCancelButton,
                    textTransform: "none",
                    color: color.CancelTextColor,
                    ":hover": {
                      backgroundColor: color.TableCancelButton,
                      textTransform: "none",
                      color: color.CancelTextColor,
                    },
                  }}
                >
                  Cancel
                </Button>
                <Button
                  type={"submit"}
                  variant="contained"
                  disabled={loading}
                  sx={{
                    textTransform: "none",
                    backgroundColor: loading
                      ? "default"
                      : color.TableButtonColor,
                    "&:hover": {
                      backgroundColor: loading
                        ? "default"
                        : color.buttonDisable,
                    },
                  }}
                >
                  Submit
                </Button>
              </Grid>
            </Grid>
          </Form>
        )}
      </Formik>
    </Box>
  );
};

export default AssetTypeQuesModal;
